import { SIMIMOVIES_MANAGED_ADS_ENABLED, SIMIMOVIES_STATIC_ADS_ENABLED } from '../config/ads';

const GRANULAR_ENV = {
  home: 'REACT_APP_SIMIMOVIES_ADS_HOME',
  search: 'REACT_APP_SIMIMOVIES_ADS_SEARCH',
  'media-detail': 'REACT_APP_SIMIMOVIES_ADS_MEDIA_DETAIL',
  similar: 'REACT_APP_SIMIMOVIES_ADS_SIMILAR',
  'similar-browse': 'REACT_APP_SIMIMOVIES_ADS_SIMILAR_BROWSE',
  explore: 'REACT_APP_SIMIMOVIES_ADS_EXPLORE',
  categories: 'REACT_APP_SIMIMOVIES_ADS_CATEGORIES',
  compare: 'REACT_APP_SIMIMOVIES_ADS_COMPARE',
  faq: 'REACT_APP_SIMIMOVIES_ADS_FAQ',
  'top-sites': 'REACT_APP_SIMIMOVIES_ADS_TOP',
  about: 'REACT_APP_SIMIMOVIES_ADS_ABOUT',
  contact: 'REACT_APP_SIMIMOVIES_ADS_CONTACT',
  legal: 'REACT_APP_SIMIMOVIES_ADS_LEGAL',
};

export function adsEnabled() {
  return SIMIMOVIES_STATIC_ADS_ENABLED || SIMIMOVIES_MANAGED_ADS_ENABLED;
}

export function adSlotVisible(pageKey) {
  if (!adsEnabled()) return false;
  if (!pageKey) return true;
  const envName = GRANULAR_ENV[pageKey];
  if (!envName) return true;
  const v = process.env[envName];
  if (v === '0' || v === 'false') return false;
  return true;
}
